import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { firebaseMutations, firebaseAction } from 'vuexfire'

Vue.use(Vuex)
Vue.use({ firebaseMutations, firebaseAction })

export default new Vuex.Store({
  state: {
    code: null,
    selectedIcons: null,
    imageQuadAnswers: null,
    codeCombos: null,
    timeStart: null,
    timeEnd: null,
    leaderboard: []
  },
  plugins: [createPersistedState()],
  mutations: {
    ...firebaseMutations,
    setCode (state, code) {
      state.code = code
    },
    setIcons (state, icons) {
      state.selectedIcons = icons
    },
    setTimeStart (state, timestamp) {
      state.timeStart = timestamp
    },
    setTimeEnd (state, timestamp) {
      state.timeEnd = timestamp
    },
    updateLeaderboard (state, scores) {
      state.leaderboard = scores
    }
  },
  actions: {
    setCode ({state, commit}, code) {
      commit('setCode', code)
    },
    setIcons ({state, commit}, icons) {
      commit('setIcons', icons)
    },
    setTimeStart ({state, commit}) {
      commit('setTimeStart', (new Date()).getTime())
    },
    setTimeEnd ({state, commit}) {
      commit('setTimeEnd', (new Date()).getTime())
    },
    updateLeaderboard: function ({ commit }, scores) {
      commit('updateLeaderboard', scores)
    },
    setImageQuadAnswersRef (context, ref) {
      return new Promise((resolve, reject) => {
        firebaseAction(({
          bindFirebaseRef
        }, ref) => {
          bindFirebaseRef('imageQuadAnswers', ref, {
            readyCallback: v => {
              resolve(context.state.imageQuadAnswers)
            },
            cancelCallback: error => {
              console.log('cancelCallback', error)
              reject(error)
            }
          })
        }, error => {
          console.log(error)
          reject(error)
        })(context, ref)
      })
    },
    setCodeCombosRef (context, ref) {
      return new Promise((resolve, reject) => {
        firebaseAction(({
          bindFirebaseRef
        }, ref) => {
          bindFirebaseRef('codeCombos', ref, {
            readyCallback: v => {
              resolve(context.state.codeCombos)
            },
            cancelCallback: error => {
              console.log('cancelCallback', error)
              reject(error)
            }
          })
        }, error => {
          console.log(error)
          reject(error)
        })(context, ref)
      })
    }
  },
  getters: {
    code: state => state.code,
    selectedIcons: state => state.selectedIcons,
    imageQuadAnswers: state => state.imageQuadAnswers,
    codeCombos: state => state.codeCombos,
    timeStart: state => state.timeStart,
    timeEnd: state => state.timeEnd,
    leaderboard: state => state.leaderboard
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js